module.exports = __webpack_public_path__ + "media/components/videos_internal/bluezones-1_1_years-af1901e1db0922a56ea081c4c2d3d06c.jpg";